import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=794e15b2&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=794e15b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e15b2",
  null
  
)

export default component.exports